module.exports = __webpack_public_path__ + "919fbd093c80df941aa88246706a0380.fbx";